<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useProgramsComparisonStore } from '@/stores/programsComparison';
import { useOptionsStore } from '@/stores/options';
import { storeToRefs } from 'pinia';

const props = defineProps({
    comparison: {
        type: Object,
        default: () => ({
            primary_program_id: null,
            secondary_program_id: null,
            is_active: true,
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const emit = defineEmits(['close-modal']);
const form = ref(
    {
        ...props.comparison,
    }
);

const toast = useToast();

const programsComparisonStore = useProgramsComparisonStore();
const { store, update } = programsComparisonStore;
const { programOptions } = storeToRefs(useOptionsStore());

const save = async () => {
    if (form.value.primary_program_id && form.value.primary_program_id === form.value.secondary_program_id) {
        toast.error('Primary and secondary program cannot be the same');
        return;
    }

    try {
        const action = props.mode === 'Create' ? store : update;
        const toastMessage = props.mode === 'Create' ? 'Programs Comparison Created' : 'Programs Comparison Updated';
        const payload = {
            primary_program_id: form.value.primary_program_id,
            secondary_program_id: form.value.secondary_program_id,
            is_active: form.value.is_active,
            hash: props.comparison.hash,
        };

        await action(payload);

        toast.success(toastMessage);
        emit('close-modal');
    } catch (error) {
        toast.error('An unexpected error occurred');
    }
};

</script>

<template>
<ModalWrapper>
    <template #header>{{ mode }} {{ $t('label.programs_comparison') }}</template>
    <template #subheader>{{ $t('label.create_or_edit', { what: $t('label.programs_comparison') }) }}</template>

    <form @submit.prevent="save">
        <div class="grid md:grid-cols-2 gap-x-4 gap-y-3">
            <StyledDropdown
                v-model="form.primary_program_id"
                :options="programOptions"
                name="primary_program_id"
                :placeholder="$t('label.primary_program')"
                :label="$t('label.primary_program')" />
            <StyledDropdown
                v-model="form.secondary_program_id"
                :options="programOptions"
                name="secondary_program_id"
                :placeholder="$t('label.secondary_program')"
                :label="$t('label.secondary_program')" />
            <StyledRoundSwitch
                v-model="form.is_active"
                :label="$t('label.active')"
                inset
                name="is_active" />
        </div>
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
